<template>
  <div v-if="null !== pages && null !== pages.total && 1 < pages.total" class="pagination">
    <div v-if="1 !== currentPage" class="pagination__controls">
      <RouterLink :to="generateLink(route, currentPage - 1)">
        <span class="control-arrow">〈</span>
        <span class="control-text">Пред</span>
      </RouterLink>
    </div>
    <div class="pagination__items">
      <RouterLink
          v-for="link in links"
          :key="link.link"
          :to="link.link"
          :class="`pagination-item ${link.isActive ? 'pagination-item_active' : ''}`">
        {{ link.label }}
      </RouterLink>
    </div>
    <div v-if="pages.total !== currentPage" class="pagination__controls">
      <RouterLink :to="generateLink(route, currentPage + 1)">
        <span class="control-text">След</span>
        <span class="control-arrow">〉</span>
      </RouterLink>
    </div>
  </div>
</template>

<script setup>
import {useRoute} from "vue-router";
import generatePagesRange from "@/components/table/utils/generatePagesRange";
import useCurrentPage from "@/components/table/hooks/useCurrentPage";
import generateLink from "@/components/table/utils/generateLink";
import generatePagesLinks from "@/components/table/utils/generatePagesLinks";
import {ref, watch} from "vue";

const props = defineProps({
  pages: {
    type: [Object, null],
  },
  size: {
    type: Number,
    default: 3,
  }
});

const route = useRoute();
const currentPage = useCurrentPage(null !== props.pages ? props.pages.total : null);
const pagesRange = generatePagesRange(currentPage.value, props.pages.total, props.size);
const links = ref([]);

watch(
    () => route.query.page,
    () => {
      links.value = generatePagesLinks(route, pagesRange, currentPage.value);
    },
{ immediate: true }
);
</script>

<style lang="scss" scoped>
@use "@/assets/styles/_colors.scss" as *;

.pagination {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;

  a {
    font-weight: normal;
    text-decoration: none;
  }

  .pagination__controls {
    .control-arrow {
      padding: 0 10px;
    }
  }

  .pagination__items {
    .pagination-item {
      background-color: white;
      border: none;
      border-radius: 5px;
      padding: 10px;

      &.pagination-item_active {
        background-color: $color-bg-secondary-grey;
        color: $color-text-primary;
      }
    }
  }
}
</style>